<template>
  <div>
    <div class="footerRowInfo">
      <div class="footer1">
        <div v-if="$store.state.darkMode">
          <img
            src="./images/cu-logoDarkMode.svg"
            class="footerPic"
            alt="Carleton University Logo"
          />
        </div>
        <div v-else>
          <img
            src="./images/dar-cu.png"
            class="footerPic"
            alt="Carleton University Logo"
          />
        </div>
      </div>
      <div class="verticalBar"></div>
      <div class="footer2">
        <div class="maxTextWidth">
          <div class="textForFooter dark:text-white">
            Mental Health <br />and Well Being
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "QuestionFooter",

  methods: {},
};
</script>

<style></style>
